import { render, staticRenderFns } from "./CardMonitoringComponent.vue?vue&type=template&id=cdabd5b6"
import script from "./CardMonitoringComponent.vue?vue&type=script&lang=js"
export * from "./CardMonitoringComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports